import * as fromRoot from '../../reducers';
import * as FuelCardsReducer from './fuel-cards.reducer';
import { Action, ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';


export interface FuelState {
  fuelCard: FuelCardsReducer.State
}

export interface State extends fromRoot.State {
  fuel: FuelState;
}

export const reducers: ActionReducerMap<FuelState, Action> = {
  fuelCard: FuelCardsReducer.reducer,
};

export const selectFuelState = createFeatureSelector<State, FuelState>('fuel');
export const selectFuelCardState = createSelector(selectFuelState, (state: FuelState) => state.fuelCard);

export const getFuelCards = createSelector(selectFuelCardState, FuelCardsReducer.getFuelCards);
export const getFilesMetaData = createSelector(selectFuelCardState, FuelCardsReducer.getFilesMetaData);
export const getFuelingMergeData = createSelector(selectFuelCardState, FuelCardsReducer.getFuelingMergeData);
